import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router';

import { SectionWrapper } from '../../components/SectionWrapper';
import { modules } from './kaiCoachContent';
import { KaiCoachSectionHead } from './KaiCoachSectionHead';

import styles from './KaiCoachDisciplinesSection.module.css';

const statusClass = {
  pilot: styles.statusPilot,
  planned: styles.statusPlanned,
  running: styles.statusRunning,
} as const;

export function KaiCoachDisciplinesSection() {
  return (
    <SectionWrapper
      aria-labelledby="kai-coach-disciplines-title"
      background="soft"
      data-testid="kai-coach-section-disciplines"
    >
      <KaiCoachSectionHead
        id="kai-coach-disciplines-title"
        kicker="Across disciplines"
        lead="Kai Coach was refined on humanities writing, where the work is a defensible argument rather than a correct final answer. The Physics pilot carries the same habit into STEM: explain the mechanism, and defend your own reasoning."
        title={
          <>
            Built in a history seminar. <em>Now moving into STEM.</em>
          </>
        }
      />
      <ul className={styles.grid}>
        {modules.map((module) => (
          <li className={styles.card} key={module.title}>
            <div className={styles.cardTop}>
              <h3 className={styles.cardTitle}>{module.title}</h3>
              <span className={`${styles.status} ${statusClass[module.tone]}`}>
                {module.status}
              </span>
            </div>
            <p className={styles.course}>{module.course}</p>
            <p className={styles.detail}>{module.detail}</p>
          </li>
        ))}
        <li className={`${styles.card} ${styles.invite}`}>
          <h3 className={styles.cardTitle}>Your course</h3>
          <p className={styles.detail}>
            Every module starts from a course’s own prompts and a previous cohort’s writing, and
            Kudu builds it at no cost to your institution. Tell us where your students stall.
          </p>
          <Link className={styles.inviteLink} to="/contact">
            Book a mapping call
            <ArrowRight aria-hidden="true" size={16} />
          </Link>
        </li>
      </ul>
    </SectionWrapper>
  );
}
